const operator = {
    'state': {
        'companyNameDisplay': 'Health Savvy',
        'companyNameOfficial': '',
        'companyRegistrationNumber': '',
        'companyLogoUrl': '',
        'privacyPolicyUrl': '',
        'supportEmailAddress': '',
        'termsAndConditionPatientsUrl': '',
        'termsAndConditionDoctorsUrl': '',
        'terms_and_conditions_panel_clinic_url': '',
        'letter_of_undertaking_panel_clinic_url': '',
        'employer_consent_of_data_sharing_letter_url': '',
        'clinic_general_terms_of_use_url': ''
    },
    'mutations': {
        initializeOperatorSetting (state, settings) {
            state.companyNameDisplay = settings.operatorCompanyNameDisplay;
            state.companyNameOfficial = settings.operatorCompanyNameOfficial;
            state.companyRegistrationNumber = settings.operatorCompanyRegistrationNumber;
            state.companyLogoUrl = settings.operatorCompanyLogoUrl;
            state.privacyPolicyUrl = settings.operatorPrivacyPolicyUrl;
            state.supportEmailAddress = settings.operatorSupportEmailAddress;
            state.termsAndConditionPatientsUrl = settings.operatorTermsAndConditionPatientsUrl;
            state.termsAndConditionDoctorsUrl = settings.operatorTermsAndConditionDoctorsUrl;
            state.terms_and_conditions_panel_clinic_url = settings.operatorTermsAndConditionPanelClinicsUrl;
            state.letter_of_undertaking_panel_clinic_url = settings.operatorLetterOfUndertakingPanelClinicsUrl;
            state.employer_consent_of_data_sharing_letter_url = settings.operatorEmployerConsentOfDataSharingLetterUrl;
            state.clinic_general_terms_of_use_url = settings.operatorClinicGeneralTermsOfUse;
        }
    }
};

export default operator;
